import { createSelector } from 'reselect';
import { KioskState } from 'store/kiosk/types';
import { RootState } from 'store/reducer';

export const kioskSelector = (state: RootState): KioskState => state.kiosk;

export const kioskEnabled = createSelector([kioskSelector], kiosk => kiosk.enabled);
